import 'motivate-framework/dist/css/motivate.css';
import $ from "jquery";
import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import './init/components/components';
import {DataTable} from 'motivate-framework-components';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
require('datatables.net-dt')
require( 'datatables.net-responsive-dt' )
require('./plugins/toaster');

window._ = require('lodash');
window.$ = $;
window.moment = require('moment-timezone');
window.moment.tz.setDefault("Europe/Amsterdam");
renderVue();
Vue.component('datatables', DataTable);
const sweetAlertoptions = {
  confirmButtonColor: '#00c9ff',
  cancelButtonColor: '#ff7674'
};
Vue.use(VueSweetalert2, sweetAlertoptions);
function renderVue() {
  new Vue({
    router: router,
    store: store,
    render: h => h(App)
  }).$mount('#app');
}
